"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    loadUrl: String,
    //树形加载数据url,
    treeData: Array,
    lazy: Boolean,
    filter: {
      //是否启用树形过滤
      type: Boolean,
      default: true
    },
    labelProp: {
      type: String,
      default: 'label'
    },
    childrenProp: {
      type: String,
      default: 'children'
    },
    valueProp: {
      type: String,
      default: 'id'
    },
    treeParentProp: {
      type: String,
      default: 'pid'
    },
    rootValue: {
      type: String,
      default: '0'
    },
    showTreeCheckbox: {
      type: Boolean,
      default: false
    },
    treeWidth: {
      type: String,
      default: '200px'
    },
    treeMethod: {
      type: String,
      default: 'get'
    }
  }
};